export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/b552ae94a3baa9664c4076d726380c66.svg";